// assembles array of JSON objects from liquid json string (typically used for variant data or fee data) only works when multiple json objects are present in string
function assembleJSONArray(liquid_string_to_json) {
  let liquidVar = liquid_string_to_json.split('},')
  let jsonObj = []
  for (let i = 0; i < liquidVar.length; i++) {
    let item = liquidVar[i]
    if (i != liquidVar.length - 1) {
      item = item+'}'
    }
    jsonObj.push(JSON.parse(item))
  }
  return jsonObj
}
// constructs a string that matches the title-format of the fee products in system
// this newly constructed "feeMatch" string is then used to correlate the product to a related fee
function assembleFeeMatch(metafield_exciseAllocation, metafield_mlInProduct) {
  let excise_allocation = metafield_exciseAllocation         
  let tax_bracket = metafield_mlInProduct

  // changes value of excise_allocation metafield to match the title of the related fee
  // this is currently hardcode
  if (excise_allocation == 'FEDERAL_ONLY') {
    excise_allocation = 'Federal Excise'
  }
  
  let matchName = `${excise_allocation} (${tax_bracket})`
  // console.log(matchName)
  return matchName
}

function betweenOrEqual(lower_upper, number) {
  return number >= lower_upper[0] && number <= lower_upper[1]
}


function addBrackets(excise_skus) {
  for (let i = 0; i < excise_skus.length; i++) {
    let item = excise_skus[i]
    let lower, upper
    let matches = item.title.match(/(\d+)mL->(\d+)mL/);
    if (matches) {
      lower = parseInt(matches[1], 10);
      upper = parseInt(matches[2], 10);
    }
    item.bracket = {lower: lower, upper: upper}
  }
}

// builds json object of item
// used for both product and fees
function assembleItemsForCart(item_id, item_quantity) {
  let data = {
    id: item_id,
    quantity: item_quantity
  }
  return data
}

  
// submits cart updates to adjust fee quantites
// fee is added if not already in cart
// reloads page by default
  // prevents reload if namesake argument is true
function synchronize_fees(fee_and_quantities, prevent_reload){ 
  let preventReload = (prevent_reload === true) ? prevent_reload : false
  let updates = fee_and_quantities
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({updates})
  })
  .then(response => {
    console.log(response.json)
    console.log(`Cart has been synchronized`)
    if (preventReload === false) {
      window.location.reload()        
    }else {
      console.log('preventing reload')
    }
  })
}

// handles cart submissions
function addProductsToCart(array_product_and_fee){ 
  let formData = {
   'items': array_product_and_fee
  }
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    // console.log(response)
    return response.json()
  })
  .catch((error) => {
    console.error('Error:', error)
  })
}

function passAttributes(element, id_string, class_string_or_array, property_object) {
  if (id_string) {
    element.id = id_string      
  }
  if (class_string_or_array) {
    if (Array.isArray(class_string_or_array)) {
      for (let i = 0; i < class_string_or_array.length; i++) {
        let item = class_string_or_array[i]
        element.classList.add(item)
      }
    }
    else {
      element.className = class_string_or_array
    } 
  }
  if (property_object) {
    if (Array.isArray(property_object)) {
      for (p in property_object) {
        element[property_object[p].property] = property_object[p].value
      }
    }
    else {
      element[property_object.property] = property_object.value
    }
    
  }
}
async function attributeHandler(obj) {
  let dataForm = {
    method:'POST',
    headers:{
      'Content-Type':'application/json'
    },
    body:JSON.stringify({
      attributes:obj})}
  await fetch('/cart/update.js', dataForm).then(()=>{return true})
}

async function thisLong(ms) {
  const D = new Promise((resolve) => {
    setTimeout(()=> {
      resolve()
    }, ms)
  })
  return D
}
function toUnix(date) {
    return Math.floor(date.getTime() / 1000);
}
function yearsAgo(years) {
    const date = new Date();
    date.setFullYear(date.getFullYear() - years);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()+1).padStart(2, '0');
    const string = `${year}-${month}-${day}`
    return {month: parseInt(month), day: parseInt(day), year: parseInt(year), string: string, unix: Date.parse(string), dateObject: date};
}

function setCookie(name, value, expireDays) {
  const d = new Date();
  d.setTime(d.getTime() + (expireDays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
}
